import { render } from "./ui-datetime-range-picker.vue?vue&type=template&id=3f1fc568&ts=true"
import script from "./ui-datetime-range-picker.vue?vue&type=script&lang=ts"
export * from "./ui-datetime-range-picker.vue?vue&type=script&lang=ts"

import "./ui-datetime-range-picker.vue?vue&type=style&index=0&id=3f1fc568&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__